import { gql } from "@apollo/client";

export const LIST_NEWS_GENERATION_RECORDS_QUERY = gql`
  query ListNewsArticles($tenantId: String!, $status: String, $limit: Int) {
    listNewsArticles(tenantId: $tenantId, status: $status, limit: $limit) {
      newsId
      title
      content
      source
      url
      publishedDate
      status
      score
      enrichedData
      timestamp
      tenantId
    }
  }
`;
